import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import "../App.css";

const Confirmation = () => {
  const navigate = useNavigate(); // Inicializar navigate
  const [headerData, setHeaderData] = useState({});
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [invoicePDF, setInvoicePDF] = useState(null);
  const [tipoDocumento, setTipoDocumento] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [proveedor, setProveedor] = useState("");
  const [envioExitoso, setEnvioExitoso] = useState(false); // <- Nuevo estado para habilitar botón
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [invoiceSent, setInvoiceSent] = useState(false);
  const [percepciones, setPercepciones] = useState([]);
  
  console.log("🧾 Confirmation.js montado");

  useEffect(() => {
    const fetchDetails = async () => {
      const tipoDocumento = localStorage.getItem("tipoDocumento");
      const nextInvoiceNumber = localStorage.getItem("nextInvoiceNumber");

      console.log("👉 tipoDocumento:", tipoDocumento);
      console.log("👉 nextInvoiceNumber:", nextInvoiceNumber);

      setTipoDocumento(tipoDocumento);
      const storedHeader = JSON.parse(localStorage.getItem("headerData"));
      setHeaderData(storedHeader || {});

      if (!nextInvoiceNumber || !tipoDocumento) {
        console.error("❌ Faltan datos requeridos para obtener detalles.");
        return;
      }

      const sheet = tipoDocumento === "Servicio" ? "DET_S" : "DET_I";

      try {
        const res = await fetch(`/api/getInvoiceDetails?sheet=${sheet}&invoiceNumber=${nextInvoiceNumber}`);
        const data = await res.json();

        console.log("📦 Datos recibidos:", data);

        if (!Array.isArray(data)) {
          console.error("🚨 Los datos recibidos no son un array:", data);
          return;
        }

        setInvoiceDetails(data);
      } catch (error) {
        console.error("❌ Error obteniendo detalles:", error);
      }
    };

    fetchDetails();
  }, []);

  useEffect(() => {
    const fetchFormaPago = async () => {
      try {
        const tipoDocumento = localStorage.getItem("tipoDocumento");
        const nextInvoiceNumber = localStorage.getItem("nextInvoiceNumber");

        if (!tipoDocumento || !nextInvoiceNumber) {
          console.error("❌ No se encontró tipoDocumento o nextInvoiceNumber para traer forma de pago");
          return;
        }

        const response = await fetch("/api/getFormaPagoFromDetalle", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ tipoDocumento, invoiceNumber: nextInvoiceNumber }),
        });

        const data = await response.json();

        if (data.formaPago) {
          setHeaderData(prev => ({
            ...prev,
            formapago: data.formaPago,
          }));
        } else {
          console.error("🚨 No se recibió forma de pago en la respuesta", data);
        }
      } catch (error) {
        console.error("❌ Error al obtener forma de pago:", error);
      }
    };

    fetchFormaPago();
  }, []);

  useEffect(() => {
    const fetchProveedor = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        const response = await fetch(`/api/get-proveedor?email=${user.email}`);
        const data = await response.json();

        if (data.proveedor) setProveedor(data.proveedor);
      } catch (error) {
        console.error("❌ Error al obtener proveedor:", error);
      }
    };

    fetchProveedor();
  }, []);

  useEffect(() => {
    const fetchPercepciones = async () => {
      const nextInvoiceNumber = localStorage.getItem("nextInvoiceNumber");
      const tipoDocumentoLocal = localStorage.getItem("tipoDocumento");
      if (!nextInvoiceNumber) return;
  
      try {
        const response = await fetch(`/api/getPercepciones?invoiceNumber=${nextInvoiceNumber}&tipoDocumento=${tipoDocumentoLocal}`);
        const data = await response.json();
  
        if (Array.isArray(data)) {
          setPercepciones(data);
        } else {
          console.error("❌ Respuesta inesperada al obtener percepciones:", data);
        }
      } catch (error) {
        console.error("❌ Error al obtener percepciones:", error);
      }
    };
  
    fetchPercepciones();
  }, []);
  
  const handleFileChange = (e) => {
    setInvoicePDF(e.target.files[0]);
  };

  const handleConfirm = async () => {
    if (!invoicePDF) {
      alert("⚠️ Debes cargar el archivo PDF antes de enviar.");
      return; // ⬅️ No avanza si no hay PDF cargado
    }
  
    setIsSending(true);
  
    try {
      const formData = new FormData();
      formData.append("file", invoicePDF);
      formData.append("nombreProveedor", proveedor); // 🔵 Agregar proveedor
  
      const response = await fetch("/api/uploadInvoicePDF", {
        method: "POST",
        body: formData,
      });
  
      const data = await response.json();
      const name = data.name || "";
      const webViewLink = data.webViewLink || "";
  
      if (!name || !webViewLink) {
        alert("❌ Error al subir el PDF.");
        setIsSending(false);
        return;
      }
  
      // 2️⃣ Enviar cabecera
      await fetch("/api/updateInvoicePDFLink", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          webViewLink,
          tipoDocumento,
          invoiceNumber: localStorage.getItem("nextInvoiceNumber"),
        }),
      });

      // 3️⃣ Actualizar importe base en hoja Percepciones
      await fetch("/api/updateImporteBasePercepciones", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          invoiceNumber: localStorage.getItem("nextInvoiceNumber"),
          importeBase: subtotalSinIVA,
          tipoDocumento: tipoDocumento, // <-- nuevo parámetro
        }),
      });

      // ✅ Mostrar modal de éxito
      setInvoiceSent(true);
      setEnvioExitoso(true); // <-- Esto faltaba también
      setShowSuccessModal(true);
  
    } catch (error) {
      console.error("❌ Error al confirmar factura:", error);
      alert("❌ Hubo un error al guardar la factura.");
    } finally {
      setIsSending(false);
    }
  };
  
  const handleCargarOtraFactura = () => {
    if (envioExitoso) {
      navigate("/tipo-comprobante"); // ⬅️ Esto ya NO recarga toda la página
    } else {
      alert("⚠️ Primero debe enviar correctamente la factura antes de cargar otra.");
    }
  };

  const cleanNumber = (value) => {
    if (typeof value !== "string") return parseFloat(value) || 0;
    return parseFloat(
      value.replace(/\./g, "").replace(",", ".") // Elimina miles y reemplaza coma por punto
    ) || 0;
  };
  
  const subtotalSinIVA = invoiceDetails.reduce((acc, detalle) => {
    const cantidad = cleanNumber(detalle.cantidad) || 0;
    const precio = cleanNumber(detalle.precioUnitario) || 0;
    return acc + (cantidad * precio);
  }, 0);
  
    return (
    <div className="confirmation-container">
      <h3 className="comprobante-title">Confirmación de Factura</h3>

      <div className="confirmation-section">
        <h3>Cabecera</h3>
        <div className="confirmation-content">
          <p><strong>Proveedor:</strong> {proveedor}</p>
          <p><strong>Número de Factura:</strong> {headerData.numeroFactura}</p>
          <p><strong>Fecha de Emisión:</strong> {headerData.fechaEmision}</p>
          <p><strong>Forma de Pago:</strong> {headerData.formapago}</p>
          <p><strong>Monto Total:</strong> ${headerData.montoTotal}</p>
        </div>
      </div>

      <div className="confirmation-section">
        <h3>Detalle</h3>
        {Array.isArray(invoiceDetails) && invoiceDetails.length > 0 ? (
          <table className="details-table">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Cantidad</th>
              <th>Precio Unitario</th>
              <th>IVA</th>
              <th>Subtotal S/IVA</th>
              <th>Subtotal C/IVA</th>
            </tr>
          </thead>
          <tbody>
            {invoiceDetails.map((detalle, index) => (
              <tr key={index}>
                <td>{detalle.descripcion}</td>
                <td>{detalle.cantidad}</td>
                <td>${detalle.precioUnitario}</td>
                <td>{detalle.iva}</td>
                <td>
                  {(() => {
                    const cantidad = cleanNumber(detalle.cantidad) || 0;
                    const precio = cleanNumber(detalle.precioUnitario) || 0;
                    return `$${(cantidad * precio).toFixed(2)}`;
                  })()}
                </td>
                <td>
                  {(() => {
                    const cantidad = cleanNumber(detalle.cantidad) || 0;
                    const precio = cleanNumber(detalle.precioUnitario) || 0;
                    const ivaStr = detalle.iva || "IVA_0";
                    const iva = cleanNumber(ivaStr.replace("IVA_", "")) || 0;
                    const subtotal = cantidad * precio;
                    const total = subtotal * (1 + iva / 100);
                    return `$${total.toFixed(2)}`;
                  })()}
                </td>
              </tr>
            ))}
            {/* Fila de Totales */}
            <tr style={{ fontWeight: 'bold', backgroundColor: 'transparent' }}>
              <td colSpan="4" style={{ textAlign: 'center' }}>Totales Detalles:</td>
              <td>
                {(() => {
                  const totalSubtotal = invoiceDetails.reduce((acc, detalle) => {
                    const cantidad = cleanNumber(detalle.cantidad) || 0;
                    const precio = cleanNumber(detalle.precioUnitario) || 0;
                    return acc + (cantidad * precio);
                  }, 0);
                  return `$${totalSubtotal.toFixed(2)}`;
                })()}
              </td>
              <td>
                {(() => {
                  const totalTotal = invoiceDetails.reduce((acc, detalle) => {
                    const cantidad = cleanNumber(detalle.cantidad) || 0;
                    const precio = cleanNumber(detalle.precioUnitario) || 0;
                    const ivaStr = detalle.iva || "IVA_0";
                    const iva = cleanNumber(ivaStr.replace("IVA_", "")) || 0;
                    const subtotal = cantidad * precio;
                    const total = subtotal * (1 + iva / 100);
                    return acc + total;
                  }, 0);
                  return `$${totalTotal.toFixed(2)}`;
                })()}
              </td>
            </tr>
          </tbody>
        </table>
        
        ) : (
          <p>No hay detalles para mostrar.</p>
        )}
      </div>

      <div className="confirmation-section">
        <h3>Percepciones / Retenciones</h3>
        {Array.isArray(percepciones) && percepciones.length > 0 ? (
          <table className="details-table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Nombre</th>
                <th>Importe Base</th>
                <th>Monto</th>
              </tr>
            </thead>
            <tbody>
              {percepciones.map((p, index) => (
                <tr key={index}>
                  <td>{p.codigo}</td> {/* Columna B */}
                  <td>{p.nombre}</td> {/* Columna C */}
                  <td>${subtotalSinIVA.toFixed(2)}</td>
                  <td>${cleanNumber(p.monto || 0).toFixed(2)}</td> {/* Columna M */}
                </tr>
              ))}
              {/* Fila de total */}
              <tr style={{ fontWeight: 'bold', backgroundColor: 'transparent' }}>
                <td colSpan="3" style={{ textAlign: 'center' }}>Total Percepciones:</td>
                <td>
                  ${percepciones.reduce((acc, p) => acc + (cleanNumber(p.monto) || 0), 0).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <p>No hay percepciones asociadas.</p>
        )}
      </div>


      <div className="confirmation-section">
        <h3>Archivo PDF</h3>
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          className="input-field"
        />
      </div>

      <div className="confirmation-footer">
      <button
          onClick={handleConfirm}
          disabled={isSending || invoiceSent}
          style={{
            cursor: isSending || invoiceSent ? "not-allowed" : "pointer",
            opacity: isSending || invoiceSent ? 0.5 : 1,
          }}
        >
          {isSending ? "Enviando..." : invoiceSent ? "Enviado" : "Confirmar y Enviar"}
        </button>
        <button
          className="secondary-button"
          disabled={!invoiceSent}
          style={{
            cursor: invoiceSent ? "pointer" : "not-allowed",
            opacity: invoiceSent ? 1 : 0.5,
          }}
          onClick={handleCargarOtraFactura}
        >
          Cargar otra factura
        </button>

      </div>
      {showSuccessModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="check-icon">✔️</div>
            <p>¡Factura enviada con éxito!</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={() => setShowSuccessModal(false)}>Aceptar</button>
            </div>
          </div>
        </div>
      )}
      {isSending && <HourglassPopup />}
      {console.log("✅ Renderizando return de Confirmation.js")}
    </div>
  );
};

const HourglassPopup = () => (
  <div className="modal-overlay">
    <div className="modal-content animated-popup">
      <div className="hourglass">⏳</div>
      <p>Enviando información. Espere por favor...</p>
    </div>
  </div>
);

export default Confirmation;





